import { inject, Pipe, PipeTransform } from '@angular/core';
import { TranslateService } from '@ngx-translate/core';
import { DocumentSignedStatusEnum } from 'src/app/domain/enums/documents/document-signed-status.enum';

@Pipe({
    name: 'signatureStatus',
    standalone: true,
    pure: false,
})
export class SignatureStatusPipe implements PipeTransform {
    private _translate = inject(TranslateService);

    transform(status: DocumentSignedStatusEnum | null | undefined): string {
        if (!status) {
            return '';
        }

        return this._translate.instant(`shared.signatureStatus.${status}`);
    }
}
